import { render } from "./successPayment.vue?vue&type=template&id=1aff2abf&scoped=true"
import script from "./successPayment.vue?vue&type=script&lang=js"
export * from "./successPayment.vue?vue&type=script&lang=js"

import "./successPayment.vue?vue&type=style&index=0&id=1aff2abf&lang=scss&scoped=true"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aff2abf"]])

export default __exports__